import React, {useEffect, useState} from "react";
import { toastr } from 'react-redux-toastr';
import CopyToClipboard from "react-copy-to-clipboard";
import { connect } from "react-redux";
import { getLocalDate, getTip } from 'utils/helpers';
import { IRootState } from "reducers";
import { USER_ROLES } from 'enums/userRoles';

import { IUserData } from "reducers/user";
import Referals from "./components/Referals";

import * as referalsAPI from 'api/referals';
import {Redirect} from "react-router";


interface IProps {
  user: IUserData;
  tips: { [key: string]: string };
}

const ReferalProgram: React.FC<IProps> = ({ user, tips }) => {
  const [isCopied, setCopied] = useState(false);
  const [referals, setReferals] = useState<any>([]);
  const [email, setEmail] = useState('');
  const [agentsFee, setAgentsFee] = useState<any>([]);

  useEffect(() => {
    referalsAPI.getReferals().then((response: any) => {
      if (response.success) {
        setReferals(response.data);
      } else {
        toastr.error('Ошибка получения данных', response.error);
      }
    });
    referalsAPI.getAgentFee().then((response: any) => {
      if (response.success) {
        setAgentsFee(response.data);
      } else {
        toastr.error('Ошибка получения данных', response.error);
      }
    })
  }, []);

  const handleSharelink = () => {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      return toastr.error('Неправильный email', '');
    } else {
      referalsAPI.shareLink({ email: email, link: refLink  }).then((response: any) => {
        if (response.success) {
          setEmail('');
        } else {
          toastr.error('Ошибка получения данных', response.error);
        }
      })
    }
  };

  const handleChangeEmail = (value: string) => {
      setEmail(value);
  }

  const refLink = `
    ${document.location!.origin}
    ${user.role_id === USER_ROLES.CAR_AGENT ? '/auth/registration' : '/auth/checkIn'}
    ?ref=${user.referalCode}
  `;

  const handleCopy = () => {
    setCopied(true);
  };

  return (
    <div className="container bug_1200">
      <div className="row bug_1200_row">
        <div className="col-12 col-lg-5">
          <div className="ref__block">
            <div className="d-md-flex justify-content-between align-items-center">
              <h3 className="ref__block-title">Моя реферальная ссылка:</h3>
              <CopyToClipboard text={refLink} onCopy={handleCopy}>
                <button className="btn ref__block-btn px-0 py-0">
                  {isCopied ? "Скопировано" : "Скопировать ссылку"}
                </button>
              </CopyToClipboard>
            </div>
            <div className="kromka" />
              <div className="form-group">
                <label htmlFor="#ref" className="mb-3 mb-md-2 mb-lg-1">
                  Поделиться ссылкой по почте:
                </label>
                <input type="text" id="ref" placeholder="ivanov@mail.ru" value={email} onChange={(e) => handleChangeEmail(e.target.value)}/>
                <a className="btn px-0 py-0 share-link-btn" onClick={handleSharelink}>Поделиться ссылкой</a>
              </div>
          </div>

          <div className="ref__block mb-lg-0 ref__results">
            <div className="d-none d-md-flex align-items-end justify-content-between">
              <h3 className="ref__block-title ref__block-titlee">
                Результаты рефералов
              </h3>
              <div className="prof__edit">{getLocalDate(new Date(), 'MMMM YYYY').charAt(0).toUpperCase() + getLocalDate(new Date(), 'MMMM YYYY').slice(1)}</div>
            </div>
            <div className="green-text d-md-block">
              <b>{agentsFee.ref_fee && agentsFee.ref_fee.points}</b>
              <span>Ваш бонус с продаж</span>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3">
              <h3 className="ref__block-title mb-0">Сделки</h3>
            </div>
            <hr className="deal-mr-bottom" />
            {referals.map((item: any, index: number) => (
              item.order_price !== 0 && <Referals {...item} key={`item-${index}`} />
            ))}

          </div>
        </div>
        <div className="col-12 col-lg-7 pl-xl-1">
          <div className="ref__block ref__block-desc">
            <div className="ref__block-title">Реферальная программа</div>
            <div className="row no-gutters">
              <div className="col-4 d-none d-md-block">
                <div className="d-flex align-items-center">
                  <div className="desc__step">1</div>
                  <div className="desc__link" />
                </div>
                <p className="desc__step-name">
                  Делитесь реферальной
                  <br /> ссылкой
                </p>
              </div>
              <div className="col-4 d-none d-md-block">
                <div className="d-flex align-items-center">
                  <div className="desc__step">2</div>
                  <div className="desc__link" />
                </div>
                <p className="desc__step-name">
                  Новый агент
                  <br /> регистрируется
                </p>
              </div>
              <div className="col-4 d-none d-md-block">
                <div className="d-flex align-items-center">
                  <div className="desc__step">3</div>
                </div>
                <p className="desc__step-name">
                  Бонус с продаж
                  <br /> нового агента
                </p>
              </div>
              <div className="col-3 d-md-none">
                <div className="desc__step mt-1">1</div>
                <div className="desc__link" />
              </div>
              <div className="col-9 d-md-none">
                <p className="desc__step-name mt-0">
                  Делитесь реферальной
                  <br /> ссылкой
                </p>
              </div>
              <div className="col-3 d-md-none">
                <div className="desc__step">2</div>
                <div className="desc__link" />
              </div>
              <div className="col-9 d-md-none">
                <p className="desc__step-name mt-0">
                  Новый агент
                  <br /> регистрируется
                </p>
              </div>
              <div className="col-3 d-md-none">
                <div className="desc__step">3</div>
              </div>
              <div className="col-9 d-md-none">
                <p className="desc__step-name mt-0">
                  Бонус с продаж
                  <br /> нового агента
                </p>
              </div>
            </div>
            <p className="ref__block-text pre-wrap">
              {getTip(14)(tips)}
            </p>
            <p className="ref__block-text ref__block-text2">
            </p>
            {/* <hr />
            <div className="d-md-flex justify-content-between">
              <div className="d-flex align-items-center mb-3 mb-md-0">
                <div className="ref__desc-svg">
                  <PdfIcon />
                </div>
                <a href="#" className="ref__desc-pdf">
                  Регламент реферальной
                  <br /> программы
                </a>
              </div>
              <div className="d-flex align-items-center">
                <div className="ref__desc-svg">
                  <PdfIcon />
                </div>
                <a href="#" className="ref__desc-pdf">
                  Общие правила реферальной
                  <br /> программы
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ user, app: { tips } }: IRootState) => ({
  user,
  tips,
});

export default connect(mapStateToProps)(ReferalProgram);
